const { location } = window;
const params = {};

/**
 * Takes an Algolia facet refinement object and pulls out data
 * for our own hash string object
 * @param {Object} refinements An Algolia refinement
 */
function addFacets(refinements) {
  const keys = Object.keys(refinements);

  if (keys.length === 0) return;

  keys.forEach((key) => {
    key = encodeURIComponent(key);
    params[key] = encodeURIComponent(refinements[key]);
  });
}

/**
 * Takes our stored params object and converts it to a string
 * used in the browser's location
 * @returns {String}
 */
function toString() {
  const pairs = [];

  Object.keys(params).forEach((key) => {
    pairs.push(`${key}=${params[key]}`);
  });

  return `#${pairs.join('&')}`;
}

/**
 * Takes an Algolia state object and creates a hash string
 * @param {Object} state An Algolia state object
 */
export default (state) => {
  params.q = encodeURIComponent(state.query);
  params.page = state.page + 1;

  addFacets(state.facetsRefinements);
  addFacets(state.disjunctiveFacetsRefinements);

  location.replace(toString());
};
